import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import HomeBannerAnimation from "cms/components/HomeBannerAnimation";
import OptimizedVideo from "index";

import {
  Container,
  Content,
  Illustration,
  Message,
  Headline,
  Pitch,
  Link,
} from "./HomepageBannerBlock.styles";

export interface HomepageBannerBlockProps
  extends Queries.SanityHomepageBannerBlock {}

const HomepageBannerBlock: React.FC<HomepageBannerBlockProps> = ({
  video,
  videoAlt,
}) => (
  <Container>
    <Content>
      <Illustration>
        {video && (
          <OptimizedVideo
            video={video}
            style={{
              width: "550px",
              maxWidth: "100%",
              maxHeight: "550px",
              borderRadius: "1.25rem",
            }}
            alt={videoAlt}
          />
        )}
      </Illustration>
      <Message>
        <Headline>
          Design stunning
          <br />
          <HomeBannerAnimation
            words={[
              "mockups",
              "mobile apps",
              "websites",
              "web apps",
              "wireframes",
              "prototypes",
              "interfaces",
            ]}
          />
          <br />
          in minutes.
        </Headline>
        <Pitch>
          The world's easiest-to-use design
          <br />
          and ideation tool - powered by AI
          <br />
          <br />
          No design experience required!
        </Pitch>
        <Link href="https://app.uizard.io/sign-up">
          <Button label="Sign up for free" variant="primary" />
        </Link>
      </Message>
    </Content>
  </Container>
);

export const query = graphql`
  fragment HomepageBannerBlock on SanityHomepageBannerBlock {
    _key
    _type
    video { ...OptimizedVideo }
    videoAlt
  }
`;

export default HomepageBannerBlock;
